export default __webpack_public_path__ + "static/media/landing-video.5161dd75.mp4";